import { Roles } from './roles.enum';

export interface EndpointPermission {
  roles: string[];
  methods?: string[];
}

export const ENDPOINT_PERMISSIONS: Record<string, EndpointPermission> = {
  'rqa/reservable-interval/common': {
    roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW],
    methods: ['GET']
  },
  'rqa/message/unread/count': {
    roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER],
    methods: ['GET']
  },
  holidays: {
    roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW],
    methods: ['GET']
  },
  note: {
    roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW],
    methods: ['GET']
  },
  airspace: {
    roles: [Roles.WEBRQA_USER, Roles.WEBRQA_DRAW, Roles.WEBRQA_VIEWER, Roles.WEBRQA_OBSERVER],
    methods: ['GET']
  }
};
